"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncAutocomplete = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var react_1 = require("react");
var lodash_1 = require("lodash");
var network_1 = require("../../network");
var async_1 = __importDefault(require("react-select/async"));
var fi_1 = require("react-icons/fi");
var customSelectStyles = {
    dropdownIndicator: function (base) { return (__assign(__assign({}, base), { color: 'rgb(157, 157, 157)' })); },
    control: function (base) { return (__assign(__assign({}, base), { border: '0', borderRadius: 20, boxShadow: 'none', backgroundColor: '#f9f9f9', flexDirection: 'row-reverse', paddingLeft: 10, '&:hover': {
            border: '0',
        } })); },
    menu: function (base) { return (__assign(__assign({}, base), { borderRadius: 0, border: '1px solid #efeeee', boxShadow: 'none' })); },
    option: function (styles, _a) {
        var isFocused = _a.isFocused, isSelected = _a.isSelected;
        return __assign(__assign({}, styles), { backgroundColor: isSelected || isFocused ? '#e0e1e3' : '#f9fafb', color: isSelected || isFocused ? '#fff' : '#000' });
    },
    placeholder: function (defaultStyles) { return (__assign(__assign({}, defaultStyles), { fontSize: 14, fontWeight: 500, color: '#98A2B3', paddingLeft: 5 })); },
    singleValue: function (provided) { return (__assign(__assign({}, provided), { fontSize: 14, fontWeight: 500 })); },
};
var AsyncAutocomplete = function (_a) {
    var setAddress = _a.setAddress, address = _a.address;
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var fullAddress = address.address;
    var defaultOption = fullAddress ? { formatted_address: fullAddress, place_id: fullAddress } : null;
    var debouncedSearch = (0, react_1.useMemo)(function () {
        return (0, lodash_1.debounce)(function (inputValue, callback) {
            network_1.maps.getGeocodeList(inputValue, i18n.language).then(function (options) { return callback(options); });
        }, 500);
    }, []);
    var onSearchAddress = function (inputValue, callback) {
        if (inputValue.length < 3) {
            return Promise.resolve([]);
        }
        debouncedSearch(inputValue, callback);
    };
    var addressNoOptionsMessage = function (_a) {
        var inputValue = _a.inputValue;
        if (inputValue.length < 3) {
            return t('Enter first 3 chars');
        }
        return t('No data');
    };
    return ((0, jsx_runtime_1.jsx)(async_1.default, { cacheOptions: true, hasValue: true, loadOptions: onSearchAddress, noOptionsMessage: addressNoOptionsMessage, loadingMessage: function () { return t('Loading'); }, value: defaultOption, placeholder: t('Address example'), getOptionLabel: function (opt) { return opt.formatted_address; }, getOptionValue: function (opt) { return opt.place_id; }, styles: customSelectStyles, isClearable: false, components: {
            IndicatorSeparator: function () { return null; },
            DropdownIndicator: function () { return (0, jsx_runtime_1.jsx)(fi_1.FiSearch, { size: 20 }); },
            LoadingIndicator: function () { return null; },
        }, onChange: function (v) {
            setAddress({
                address: v.formatted_address,
                lng: v.geometry.location.lng,
                lat: v.geometry.location.lat,
            });
        } }));
};
exports.AsyncAutocomplete = AsyncAutocomplete;
